<template lang="html">
	<div id="page__stock__workers"  class="center-panel">
		<md-content md-theme="white" v-bind:loading="progress">
			<sort-table
				v-bind:columns="tableColumns" v-model="responsibles" @refresh="getResponsibles" v-bind:per-page="perPage" v-bind:total="1" ref="table"
				v-on:create="addUser" table-id="stock-workers" link 
			>
				<template slot="groups" slot-scope="scope">
					<div class="chips">
						<div class="chip" v-for="item in scope.item.groups"> {{item.name}} </div>
					</div>
				</template>
				<template slot="actions" slot-scope="scope">
					<z-icon-button v-bind:icon="['fa', 'trash']" danger-light  rounded v-on:click.stop.prevent="onRemove(scope.item.id)"></z-icon-button>
				</template>
				<template slot="buttons" slot-scope="scope">
					<md-button class="md-dense" v-on:click="back"><md-icon>keyboard_backspace</md-icon>Вернуться к складам</md-button>
					<md-button class="md-dense" v-on:click="addUser">Добавить<md-icon>add</md-icon></md-button>
				</template>
			</sort-table>
		</md-content>
	</div>
</template>
<script>
	import CustomerMenu from './menu.vue';
	import SortTable from "@/components/SortTable";
	import ZIconButton from '@/components/ZIconButton.vue';
	import ZInputAutocomplete from '@/components/ZInputAutocomplete';
	export default {
		components: {CustomerMenu, SortTable, ZInputAutocomplete, ZIconButton},
		data() {
		return {
				tableColumns: [
					{ label: 'Логин', field: 'login', sortable: true },
					{ label: 'ФИО', field: 'fio', sortable: true },
					{ label: 'Email', field: 'email', sortable: true },
					{ label: 'Роли',  field: 'groups', sortable: false },
					{ label: '', field: 'actions' },
				],
				perPage: 50
			}
		},
		computed: {
			/**
			 * Флаг загрузки текущего компонента
			 */
			progress() {
				return this.progressObj['load-stockworkers-card'];
			},
			/**
			 * Объект с флагами загрузки
			 */
			progressObj() {
				return this.$store.state.progressObj;
			},
			/**
			 * Список работников склада
			 */
			responsibles() {
				return this.$store.state.stock.responsibles.map(responsible => {
					responsible.routerLink = {name: 'User', params: {user_id: responsible.id}};
					return responsible;
				});
			},
		},
		created() {
			this.init();
		},
		methods: {
			/**
			 * Ициализация компонента
			 */
			init() {
				this.$store.commit('setTitle', 'Пользователи');
				this.getResponsibles();
				if (this.stock && this.stock.name) this.$store.commit('setTitle', ('Склады | ' + this.stock.name + ' | Пользователи'))
			},
			/**
			 * Добавление пользователя
			 */
			addUser() {
				this.$router.push({'name': 'StockWorker', params: {stock_id: this.$route.params.stock_id, id: 'new'}});
			},
			/**
			 * 
			 */
			getResponsibles() {
				this.$store.commit('showProgressBar', 'load-stockworkers-card');
				return this.$store.dispatch('stock/getStockResponsibles', this.$route.params.stock_id )
					.finally(() => this.$store.commit('hideProgressBar', 'load-stockworkers-card'));
			},
			/**
			 * Удаление пользователя
			 */
			detachUser(id) {
				this.$store.commit('showProgressBar', 'load-stockworkers-card');
				this.$store.dispatch('stock/detachUser', { userId: id, stockId: this.$route.params.stock_id })
					.then(() => this.$root.$emit('refresh-table', 'stock-workers'))
					.finally(() => this.$store.commit('hideProgressBar', 'load-stockworkers-card'));
			},
			/**
			 * Модальное окно с подтверждением удаления пользователя
			 */
			onRemove(id) {
				this.$root.$emit(
					'z-alert', 'Вы уверены в удалении пользователя', 'Действие необратимо!',
					() => this.detachUser(id)
				);
			},
            /**
             * Возврат на предидущую страницу
             */
			 back() {
                this.$router.go(-1);
            }			
		}
  	}
</script>



// WEBPACK FOOTER //
// StockWorkers.vue?9b8cd168